import React from "react";
import { Card, Container } from "reactstrap";
import "./LcaCards.css"; // Import your custom CSS file
import "moment-timezone/builds/moment-timezone-with-data";
import CarouselComponent from "./BizzList";
import BwvBox from "./BwvBox";

const BwvCards = ({ currentVendors, carouselData }) => {
  return (
    <Container>
      {currentVendors && currentVendors.length > 0 && (
        <>
          {currentVendors.map((ad, index) => (
            <div key={ad.Id}>
              <p className="mb-0" style={{ fontSize: "medium" }}>
                {ad?.FullName}
              </p>
              <BwvBox ad={ad} />
              {index === 2 && carouselData.row1.length > 0 && (
                <Card className="my-2 mb-0 border-white d-block">
                  <CarouselComponent items={carouselData.row1} />
                </Card>
              )}
              {index === 5 && carouselData.row2.length > 0 && (
                <Card className="my-2 mb-0 border-white d-block">
                  <CarouselComponent items={carouselData.row2} />
                </Card>
              )}
              {index === 8 && carouselData.row3.length > 0 && (
                <Card className="my-2 mb-0 border-white d-block">
                  <CarouselComponent items={carouselData.row3} />
                </Card>
              )}
            </div>
          ))}
        </>
      )}
    </Container>
  );
};

export default BwvCards;
